import { Table, Input, Button } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import React from 'react';

class TablaOrganismos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      visibleFiltroCircunscripcion: false,
      data: this.props.certificaciones,
      textoBuscarNombre: '',
      textoBuscarCircunscripcion: '',
      filtered: false,
      filteredCircunscripcion: false,
    };
  }

  onInputChange = e => {
    this.setState({ textoBuscarNombre: e.target.value });
  };

  onApellidoChange = e => {
    this.setState({ textoBuscarApellido: e.target.value });
  };

  onUsernameChange = e => {
    this.setState({ textoBuscarUsername: e.target.value });
  };

  onCircunscripcionChange = e => {
    this.setState({ textoBuscarCircunscripcion: e.target.value });
  };

  render() {
    const columns = [
      {
        title: 'ID',
        dataIndex: '_id',
        key: '_id',
      },
      {
        title: 'Nombre',
        dataIndex: 'nombre',
        key: 'nombre',
        render: text => text.toUpperCase(),
        filterDropdown: (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Buscar nombre"
              value={this.state.textoBuscarNombre}
              onChange={this.onInputChange}
              onPressEnter={() =>
                this.props.filtrarPorNombre(this.state.textoBuscarNombre)
              }
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorNombre(this.state.textoBuscarNombre)
              }
            >
              Buscar
            </Button>
          </div>
        ),
        filterIcon: (
          <Icons.FilterOutlined
            style={{ color: this.state.filtered ? '#108ee9' : '#aaa' }}
          />
        ),
        filterDropdownVisible: this.state.filterDropdownVisible,
        onFilterDropdownVisibleChange: visible => {
          this.setState(
            {
              filterDropdownVisible: visible,
            },
            () => this.searchInput && this.searchInput.focus()
          );
        },
      },
      // {
      //   title: "Telefono",
      //   dataIndex: "telefono",
      //   key: "telefono"
      // },
      {
        title: 'Ciudad',
        dataIndex: 'ciudad',
        key: 'ciudad',
      },
      {
        title: 'Circunscripcion',
        dataIndex: 'circunscripcion',
        key: 'circunscripcion',
        filterDropdown: (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput2 = ele)}
              placeholder="Buscar Circunscripcion"
              value={this.state.textoBuscarCircunscripcion}
              onChange={this.onCircunscripcionChange}
              onPressEnter={() =>
                this.props.filtrarPorCircunscripcion(
                  this.state.textoBuscarCircunscripcion
                )
              }
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorCircunscripcion(
                  this.state.textoBuscarCircunscripcion
                )
              }
            >
              Buscar
            </Button>
          </div>
        ),
        filterIcon: (
          <Icons.FilterOutlined
            style={{
              color:
                this.state.textoBuscarCircunscripcion &&
                this.state.textoBuscarCircunscripcion.length > 0
                  ? '#108ee9'
                  : '#aaa',
            }}
          />
        ),
        filterDropdownVisible: this.state.visibleFiltroCircunscripcion,
        onFilterDropdownVisibleChange: visible => {
          this.setState(
            {
              visibleFiltroCircunscripcion: visible,
            },
            () => this.searchInput2 && this.searchInput2.focus()
          );
        },
      },
      // {
      //   title: "Direccion",
      //   dataIndex: "direccion",
      //   key: "direccion",
      // },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <span>
            <Button
              onClick={() =>
                this.props.history.push(`/admin/organismos/${record._id}`)
              }
            >
              Editar
            </Button>
          </span>
        ),
      },
    ];
    const { organismos } = this.props;
    return (
      <Table
        rowKey="_id"
        columns={columns}
        pagination={this.props.pagination}
        dataSource={organismos}
        title={() => <h2 style={{ textAlign: 'center' }}> Organismos </h2>}
        bordered
        locale={{
          emptyText: 'No hay organismos cargados',
        }}
      />
    );
  }
}

export default TablaOrganismos;
